import {http} from "@/assets/utils/api";

/**
 * 发送验证码
 */
export const getCode = (params) => http.get('/app/getCode',{params,custom:{isAuth:false}});

/**
 * 登录
 */
export const login = (data) => http.post('/app/login',data,{custom:{isAuth:false}});

/**
 * 密码登录
 * @returns 
 */
export const loginByPwd = (data) => http.post('/app/loginByPass',data,{custom:{isAuth:false}});

/**
 * 获取用户信息
 */
export const getUserInfo = () => http.get('/user/getUser');

/**
 * 协议
 */
export const getAgreement = (code) => http.get('/yymPlatformArticles/getByCode/'+code);